/**
 * @desc 报警消息列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AlertMessageInfoRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AlertMessageInfoResponse>>> {
  return defHttp.post({
    url: '/wap/alert/message/listAlertMessage',
    data,
  });
}

export function mock(
  data: defs.AlertMessageInfoRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AlertMessageInfoResponse>>> {
  return defHttp.post({
    url: '/mock/wap/alert/message/listAlertMessage',
    data,
  });
}
